import GATSBY_COMPILED_MDX from "/opt/build/repo/src/data/teams/2025/2025-plakata-buffalo-ny/index.mdx";
import React from "react";
import DefaultTitle from "../../layouts/default-title";
import DefaultLayout from "../../layouts/default/default.layout";
import {PromotionDetailHead, PromotionDetailTemplate} from "../../templates/promotions/promotions-detail.template";
import Team2023DetailsPage from "../../templates/parks-and-rec/2023/_2023-details.page";
import Teams2024Template from "../../templates/parks-and-rec/2024/_2024.template";
import Teams2025Template from "../../templates/parks-and-rec/2025/_2025.template";
export const MDXSlugPage = props => {
  if (("fields__source" in props.pageContext)) {
    switch (props.pageContext.fields__source) {
      case "promotions":
        return React.createElement(PromotionDetailTemplate, Object.assign({
          frontmatter: props.data.mdx.frontmatter
        }, props));
      case "teams/2023":
        return React.createElement(Team2023DetailsPage, Object.assign({}, props, {
          children: props.children
        }));
      case "teams/2024":
        return React.createElement(Teams2024Template, Object.assign({}, props, {
          children: props.children
        }));
      case "teams/2025":
        return React.createElement(Teams2025Template, Object.assign({}, props, {
          children: props.children
        }));
    }
  }
  return React.createElement(DefaultLayout, null);
};
MDXSlugPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(MDXSlugPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = props => {
  if (("fields__source" in props.pageContext)) {
    switch (props.pageContext.fields__source) {
      case "promotions":
        return React.createElement(PromotionDetailHead, Object.assign({}, props, {
          data: props.data.mdx
        }));
      case "teams/2023":
      case "teams/2024":
      case "teams/2025":
        const {name, year} = props.data.mdx.frontmatter;
        if (name) return React.createElement(DefaultTitle, Object.assign({
          title: name + ": Parks and Rec",
          metaDescription: "Sponsored by Labatt USA for " + year
        }, props));
        return React.createElement(DefaultTitle, Object.assign({
          title: "Parks and Rec"
        }, props));
    }
  }
  return React.createElement(DefaultTitle, props);
};
const query = "3994217628";
